import HttpCliente from '../services/HttpClient';
import axios from 'axios';

const instancia = axios.create();
instancia.CancelToken = axios.CancelToken;
instancia.isCancel = axios.isCancel;

export const getUsuarioById = (id) => {
    return new Promise( (resolve, eject) => {
        HttpCliente.get(`/api/usuario/account/${id}`)
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            resolve(error.response);
        })
    });
}

export const agregarRole = (id, role, dispatch) => {
    return new Promise((resolve, eject) => {
        HttpCliente.put(`/api/usuario/role/${id}`, role)
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            resolve(error.response)
        });
    })
}




export const getUsuarios = (request) => {
    console.log('entrando al action, solo entró', request);
    return new Promise( (resolve, eject) => {
        HttpCliente.get(`/api/usuario/pagination?pageIndex=${request.pageIndex}&pageSize=${request.pageSize}&search=${request.search}`)
        .then(response => {
            resolve(response);
        })
        .catch( error => {
            resolve(error.response);
        });
    });
}


export const actualizarUsuario = async (id, usuario, dispatch) => {
    // 20251025-AL REACTIVAR CON EL LLAMADO AL FIREBASE CONFIGURADO EN ESTA APLICACION IGUAL QUE EN components/workflow/ModalSubirDocumento **************OJOJOJOJOJOJO
    // if(usuario.file){
    //     const urlImage = await uploadImage(usuario.file);
    //     usuario.imagen = urlImage;
    // }
    
    return new Promise((resolve, reject) => {
        console.log('=== INICIO LLAMADA API ACTUALIZAR USUARIO ===');
        console.log('ID:', id);
        console.log('Datos a enviar:', JSON.stringify(usuario, null, 2));
        console.log('URL completa:', `/api/usuario/actualizar/${id}`);
        
        HttpCliente.put(`/api/usuario/actualizar/${id}`, usuario)
        .then(response => {
            console.log('✅ Respuesta exitosa:', response);
            resolve(response);
        })
        .catch(error => {
            console.error('❌ ERROR EN LA PETICIÓN:');
            console.error('Error completo:', error);
            
            if (error.response) {
                // El servidor respondió con un código de estado fuera del rango 2xx
                console.error('📋 Detalles del error del servidor:');
                console.error('Status:', error.response.status);
                console.error('Data:', error.response.data);
                console.error('Headers:', error.response.headers);
                
                // Mostrar mensaje específico si existe
                if (error.response.data?.message) {
                    console.error('Mensaje del servidor:', error.response.data.message);
                }
                if (error.response.data?.errors) {
                    console.error('Errores de validación:', error.response.data.errors);
                }
            } else if (error.request) {
                // La petición se hizo pero no se recibió respuesta
                console.error('📡 No se recibió respuesta del servidor');
                console.error('Request:', error.request);
            } else {
                // Algo pasó al configurar la petición
                console.error('⚙️ Error al configurar la petición:', error.message);
            }
            console.error('=== FIN ERROR ===');
            
            reject(error);
        });
    });
}   

// export const actualizarUsuario = async (id, usuario, dispatch) => {
//     // 20251025-AL REACTIVAR CON EL LLAMADO AL FIREBASE CONFIGURADO EN ESTA APLICACION IGUAL QUE EN components/workflow/ModalSubirDocumento **************OJOJOJOJOJOJO
//     // if(usuario.file){
//     //     const urlImage = await uploadImage(usuario.file);
//     //     usuario.imagen = urlImage;
//     // }
//     return new Promise((resolve, reject) => {
//         console.log('estamos en el llamado al api del react, esto se envía: ', usuario);
//         HttpCliente.put(`/api/usuario/actualizar/${id}`, usuario)
//         .then(response => {
//             resolve(response); // Pasar toda la respuesta al resolver la promesa
//         })
//         .catch(error => {
//             reject(error); // Rechazar la promesa en caso de error
//         });
//     });
// }

// este es el registro que no requiere confirmación de correo y de una vez inicia la sesión
export const registrarusuario = (usuario, dispatch)  => {
    return new Promise((resolve, eject) =>{
        instancia.post("/api/usuario/registrar", usuario).then( response => {

            dispatch({
                type: "INICIAR_SESION",
                sesion: response.data,
                autenticado: true
            })

            resolve(response);
        })
        .catch((error) => {
            resolve(error.response);
        })
    });
}

//Este es el registro para la estructura que requiere confirmación desde email enviado al usuario
export const registrarusuarioEmail = (usuario, dispatch)  => {
    return new Promise((resolve, reject) =>{
        instancia.post("/api/usuario/registrar", usuario).then( response => {

            // dispatch({
            //     type: "INICIAR_SESION",
            //     sesion: response.data,
            //     autenticado: true
            // })

            resolve(response);
        })
        .catch((error) => {
            reject(error);
        })
    });
}



export const loginUsuario = (usuario, dispatch) => {
    return new Promise((resolve, reject) => {
        
        instancia.post("/api/usuario/login", usuario).then(response => {
            // //console.log('se va a publicar el estado, viene el dispatch');
            //envío al reducer para cambiar el valor de la variable global
            dispatch({
                type: "INICIAR_SESION",
                sesion: response.data,
                autenticado: true
            })

            resolve(response);
        })
        .catch((error) => {
            // console.log("error del api login",error.message, error);
            
            reject(error);
            // if (error.message.includes('ERR_CONNECTION_REFUSED')) {
                // Swal.fire({
                //     title: 'Servidor no disponible',
                //     text: 'No se puede conectar al servidor. Por favor, intente nuevamente más tarde.',
                //     icon: 'error'
                // });
            // } else {
                // Manejar otros errores
            // }
        })
    });
}

export const TwoFactorAuth = (usuario, dispatch) => {
    return new Promise((resolve, reject) => {
        
        instancia.post("/api/usuario/login", usuario).then(response => {
            // //console.log('se va a publicar el estado, viene el dispatch');
            //envío al reducer para cambiar el valor de la variable global
            // dispatch({
            //     type: "INICIAR_SESION",
            //     sesion: response.data,
            //     autenticado: true
            // })
            resolve(response);
        })
        .catch((error) => {
            // console.log("error del api login",error.message, error);
            reject(error);
        })
    });
}


// export const loginUsuario = (usuario, dispatch) => {
//     return new Promise((resolve, reject) => {
//         instancia.post("/api/usuario/login", usuario)
//             .then(async response => {
//                 window.localStorage.setItem('token', response.data.token);
//                 // Lógica para obtener el token de Firebase
//                 let firebaseToken;
//                 try {

//                     getLoginFa().then((response) => {
//                         //console.log('respuesta de token fireb:',response);
//                         if(response.status === 200){
//                             // hideLoading();
//                             window.localStorage.setItem('tokenF', response.data.token);
//                             // //console.log('el login fue exitoso', response.data);
//                             // props.history.push('/');
//                             firebaseToken = response.data.token;
//                         }
//                         else
//                         {
//                             console.error('Hubo un problema al conectar el usuario F!', response.status);
//                         }
//                     }).catch(error => {
//                         // hideLoading();
//                         // Maneja cualquier error que ocurra durante la solicitud
//                         console.error('Hubo un problema al conectar el usuario F!', error);
//                     });
//                     // const firebaseResponse = await fetch('/api/usuariof/loginfa');
//                     // //console.log(firebaseResponse);
//                     // if (!firebaseResponse.ok) {
//                     //     // throw new Error('Failed to fetch Firebase token');
//                     //     //console.log('Failed to fetch Firebase token');
//                     // }
//                     // const firebaseData = await firebaseResponse.json();
//                     // const firebaseToken = firebaseData.token;
//                     // //console.log('firebasetoken: ' + firebaseToken); 

//                     // Envía al reducer para cambiar el valor de la variable global
//                     dispatch({
//                         type: "INICIAR_SESION",
//                         sesion: response.data,
//                         autenticado: true,
//                         firebaseToken: firebaseToken // Envía el token de Firebase al reducer
//                     });

//                     resolve(response);
//                 } catch (error) {
//                     console.error('Error fetching Firebase token:', error);
//                     reject(error);
//                 }
//             })
//             .catch((error) => {
//                 console.error('Login error:', error);
//                 reject(error.response);
//             });
//     });
// };









export const getUsuario= (dispatch) => {
    return new Promise((resolve, eject) => {
        HttpCliente.get("/api/usuario").then(response => {

            dispatch({
                type: "INICIAR_SESION",
                sesion: response.data,
                autenticado: true
            })

            resolve(response);
        })
        .catch(error => {
            resolve(error.response);
        })
    });
}

export const getAreas= (dispatch) => {
    return new Promise( (resolve, eject) => {
        HttpCliente.get(`/api/usuario/areas`)
        .then(response => {
            resolve(response);
        })
        .catch( error => {
            resolve(error.response);
        });
    });
}

export const getRoles= (dispatch) => {
    return new Promise( (resolve, eject) => {
        HttpCliente.get(`api/usuario/roles`)
        .then(response => {
            resolve(response);
        })
        .catch( error => {
            resolve(error.response);
        });
    });
}

export const agregarDireccion = (id, direccion) => {
    //console.log("direccion en api", direccion);
    return new Promise((resolve, eject) => {
        HttpCliente.post(`/api/usuario/InsertDireccion?id=${id}`, direccion)
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            resolve(error.response)
        });
    })
}

export const getDireccionById = (id) => {
    return new Promise( (resolve, eject) => {
        HttpCliente.get(`/api/usuario/getdireccionbyid?id=${id}`)
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            resolve(error.response);
        })
    });
}

export const eliminarDireccion = (id, direccion) => {
    //console.log('direccion a eliminar en action:', direccion);
    return new Promise( (resolve, eject) => {
        HttpCliente.post(`/api/usuario/deletedireccion?id=${id}`, direccion)
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            resolve(error.response);
        })
    });
}

export const actualizarDireccion = async (id, direccion, dispatch) => {
    
    return new Promise((resolve, reject) => {
        HttpCliente.put(`/api/usuario/updatedireccion?id=${id}`, direccion)
        .then(response => {
            resolve(response); // Pasar toda la respuesta al resolver la promesa
        })
        .catch(error => {
            reject(error); // Rechazar la promesa en caso de error
        });
    });
    // return new Promise( (resolve, eject) => {
    //     HttpCliente.put(`/api/usuario/actualizar/${id}`, usuario)
    //     .then( response => {
    //         dispatch({
    //             type: "ACTUALIZAR_USUARIO",
    //             nuevoUsuario: response.data,
    //             autenticado: true
    //         });
    //         resolve(response);
    //     })
    //     .catch( error => {
    //         resolve(error.response);
    //     })
    // })
}

export const actualizarAreas = async (id, areasAsignadas, dispatch) => {
    return new Promise((resolve, reject) => {
        HttpCliente.put(`/api/usuario/updateareas/${id}`, areasAsignadas)
        .then(response => {
            resolve(response); // Pasar toda la respuesta al resolver la promesa
        })
        .catch(error => {
            reject(error); // Rechazar la promesa en caso de error
        });
    });
}

export const actualizarRoles = async (id, rolesAsignados, dispatch) => {
    return new Promise((resolve, reject) => {
        HttpCliente.put(`/api/usuario/updateroles/${id}`, rolesAsignados)
        .then(response => {
            resolve(response); // Pasar toda la respuesta al resolver la promesa
        })
        .catch(error => {
            reject(error); // Rechazar la promesa en caso de error
        });
    });
}